import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { getSurveyData } from "components/MySurveys/MySurveys.api";
import { postSuccessOps } from "components/MySurveys/utils/onSurveyFetchedSucessful";
import { IP_REGISTRY_KEY, IP_URL } from "config/constants";

export const useSurveyQuery = function (country, langCode, userId, searchQuery) {
  const { data, ...rest } = useQuery(
    ["survey", country],
    () =>
      getSurveyData({
        userId,
        page: 1,
        userLangCode: langCode,
        sortColumnName: "Date",
        sortColumnOrder: "DESC",
        country,
        searchQuery,
      }),
    {
      enabled: !!country,
      refetchOnWindowFocus: false,
      onSuccess: (result) => {
        postSuccessOps(result);
      },
    }
  );
  return {
    surveys: data?.result.filter((survey) =>
      survey.studyName.toLowerCase().includes(searchQuery.toLowerCase())
    ),
    surveyLength: data?.result?.length,
    pages: Math.ceil(data?.result?.length / 10),
    ...rest,
  };
};

export const getDataa = async ({ setCountry, setLangCode, setCountryChangeMessage, auth, t }) => {
  const res = await axios.get(`${IP_URL}?key=${IP_REGISTRY_KEY}`);
  if (res.data.currency === "USD") {
    setCountry("USA");
    setLangCode("En-US");
  } else if (res.data.currency == "CAD") {
    setCountry("Canada");
    setLangCode("English-CA");
  } else if (res.data.currency == "GBP") {
    setCountry("UK");
    setLangCode("En-US");
  } else if (res.data.currency == "INR") {
    setCountry("India");
    setLangCode("English-IN");
  } else {
    setCountry(res.data.country_name);
    setLangCode(res.data.country_name + "-" + res.data.country);
  }
  if (res && res.data) {
    if (auth?.user_country?.includes(res.data.country_name)) {
      setCountryChangeMessage(
        <div>
          {t("page.mysurvey.System")} <b>{res.data.country_name}</b> {t("page.mysurvey.country")}{" "}
          <b>{res.data.country_name}</b> {t("page.mysurvey.listed")}
        </div>
      );
    } else {
      setCountryChangeMessage(null);
   }
  }
};
